"use client";
import clsx from "clsx";

/**
 * 曜日 7 ラベルの flex 行 (日〜土)。scroll / paged 両シェルで共有する。
 * sticky 化やパディングなどの配置はラップする側の責務。
 */
export function DayOfWeekHeader({
  labels,
  className,
}: {
  labels: readonly string[];
  className?: string;
}) {
  return (
    <div
      className={clsx("flex w-full items-center justify-between", className)}
    >
      {labels.map((label) => (
        <div
          key={label}
          className="flex h-[32px] min-w-[32px] flex-[1_0_0] items-center justify-center"
        >
          <p className="text-dx-text-sub text-center text-[12px] leading-[16px] whitespace-nowrap">
            {label}
          </p>
        </div>
      ))}
    </div>
  );
}
